import {BalanceTillBreakdownReportData} from "./balance-till-breakdown-report.data";
import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class BalanceTillBreakdownReportModel extends ReportModel<BalanceTillBreakdownReportData> {
    constructor(injector: Injector) {
        super(injector, BalanceTillBreakdownReportData);
    }
}
